import Resource from './Resource';
import Attributes from 'Attributes/StandardIntegrationAttributes';

class StandardIntegrationSettings extends Resource {
	constructor() {
		super('standardIntegrationSettings', Attributes);
	}
	async save(data, opts = {}) {
		const result = await super.save(data, opts);
		return result;
	}
}

const resource = new StandardIntegrationSettings();
window.Tools.StandardIntegrationSettings = resource;
export default resource;
